import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const generateCertificateApiService = createApi({
  reducerPath: "generateCertificateApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    generateCertificate: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `certificate/generate-certificate${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    createCertificateDowloaded: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `certificate/certificatetotal${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useGenerateCertificateMutation,
  useCreateCertificateDowloadedMutation,
} = generateCertificateApiService;
